/* IKONICK FALL: apply the real Shopify code through the same AJAX endpoint used by the theme. */
(() => {
  const optedOutKey = 'ikonick-fall-code-removed';
  const autoAppliedKey = 'ikonick-fall-code-auto-applied';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let busy = false;
  let rejected = false;
  const getSettings = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.dataset.ikonickFallCart !== 'true') return null;
    const code = (drawer.dataset.ikonickFallCode || 'FALL').trim();
    const eligibleProductIds = new Set(
      Array.from(drawer.querySelectorAll('[data-ikonick-fall-eligible-product-id]'))
        .map(el => String(el.getAttribute('data-ikonick-fall-eligible-product-id')))
    );
    return code ? {code, eligibleProductIds} : null;
  };
  const wasRemoved = () => {
    try { return sessionStorage.getItem(optedOutKey) === '1'; } catch (e) { return false; }
  };
  const markRemoved = () => {
    try { sessionStorage.setItem(optedOutKey, '1'); } catch (e) {}
  };
  const readAutoApplied = () => {
    try { return sessionStorage.getItem(autoAppliedKey) === '1'; } catch (e) { return false; }
  };
  const setAutoApplied = (yes) => {
    try {
      if (yes) sessionStorage.setItem(autoAppliedKey, '1');
      else sessionStorage.removeItem(autoAppliedKey);
    } catch (e) {}
  };
  // Prevent auto-applying again after shoppers deliberately remove FALL.
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('cart-discount-remove-button');
    const settings = getSettings();
    if (button && settings && (button.getAttribute('discount-code') || '').toLowerCase() === settings.code.toLowerCase()) { markRemoved(); setAutoApplied(false); }
  }, true);
  async function applyFall() {
    const settings = getSettings();
    if (!settings || busy || rejected) return;
    busy = true;
    try {
      const cartResponse = await fetch(root + 'cart.js', {credentials:'same-origin'});
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const hasEligibleProduct = (cart.items || []).some(item =>
        settings.eligibleProductIds.has(String(item.product_id))
      );
      const fallCodePresent = codes.some(item => (item.code || '').toLowerCase() === settings.code.toLowerCase());
      if (!hasEligibleProduct) {
        // Only remove FALL if this script applied it earlier; never remove a code
        // deliberately entered by the shopper, and preserve all other codes.
        if (fallCodePresent && readAutoApplied()) {
          const otherCodes = codes.filter(item => (item.code || '').toLowerCase() !== settings.code.toLowerCase() && item.applicable).map(item => item.code);
          const response = await fetch(root + 'cart/update.js', {
            method: 'POST', headers: {'Content-Type': 'application/json'}, credentials: 'same-origin',
            body: JSON.stringify({discount: otherCodes.join(',')})
          });
          if (response.ok) {
            setAutoApplied(false);
            document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
          }
        }
        return;
      }
      if (fallCodePresent || wasRemoved()) return;
      // Do not override a different promotion chosen by the customer.
      if (codes.length) return;
      const result = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'same-origin',
        body: JSON.stringify({discount: settings.code})
      });
      if (!result.ok) { rejected = true; return; }
      const updated = await result.json();
      const applied = Array.isArray(updated.discount_codes) && updated.discount_codes.some(item =>
        (item.code || '').toLowerCase() === settings.code.toLowerCase() && item.applicable
      );
      if (!applied) { rejected = true; return; }
      setAutoApplied(true);
      document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
    } catch (e) {
      // Keep the cart functional if the discounts API is temporarily unavailable.
    } finally { busy = false; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFall, {once: true});
  else applyFall();
  document.addEventListener('cart:change', applyFall);
  document.addEventListener('cart-drawer:refreshed', applyFall);
})();
